// extracted by mini-css-extract-plugin
module.exports = {"id":"OrderQuantityForm_id__ae_Do","tableColumn":"OrderQuantityForm_tableColumn__1Xe5b"};